import { type FC, useEffect, useState } from 'react';
import { Box, Button, Flex, Text } from '@eqi-investimentos/react';
import {
  INVESTMENT_ORDER_TYPES_TRANSLATE,
  type InvestmentOrder,
} from '@/modules/Wallet/interface/invest';
import { useT } from '@/libs/i18n/utils/useT';
import { formatNumberToPTBRCurrency } from '@/utils/format';
import { IfRender } from '@/utils/jsx';
import { ConfirmSendOrderAdvisorSkeleton } from './Skeleton';

export const ConfirmSendOrderAdvisor: FC<ConfirmSendOrderAdvisorProps> = ({
  orderDataToSend,
  handleBack,
  handleConfirmAndSend,
}) => {
  const t = useT();
  const [loading, setLoading] = useState(true);

  const title =
    'title' in orderDataToSend.asset
      ? orderDataToSend.asset.title
      : orderDataToSend.asset.name;

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <Box pos="relative" px="3xl" w="full" h="calc(100vh - 10rem)">
      <IfRender condition={loading}>
        <ConfirmSendOrderAdvisorSkeleton />
      </IfRender>
      <IfRender condition={!loading}>
        <Flex gap="s" flexDir="column" h="full" justify="space-between">
          <Flex flexDir="column" gap="s">
            <Text size="h6" color="content.primary">
              {t('screens.invest.confirmOrder.title')}
            </Text>
            <Flex justify="space-between">
              <Text size="l" color="content.primary" fontWeight="semibold">
                {t('screens.invest.confirmOrder.table.asset')}
              </Text>
              <Text size="l" color="content.primary">
                {title}
              </Text>
            </Flex>
            <Flex justify="space-between">
              <Text size="l" color="content.primary" fontWeight="semibold">
                {t('screens.invest.confirmOrder.table.order')}
              </Text>
              <Text
                size="l"
                fontWeight="bold"
                color={
                  orderDataToSend?.type === 'buy'
                    ? 'alert.success'
                    : 'alert.error'
                }
              >
                {INVESTMENT_ORDER_TYPES_TRANSLATE[orderDataToSend?.type]}
              </Text>
            </Flex>
            <Flex justify="space-between">
              <Text size="l" color="content.primary" fontWeight="semibold">
                {t('screens.invest.confirmOrder.table.value')}
              </Text>
              <Text size="l" color="content.primary">
                {formatNumberToPTBRCurrency(Number(orderDataToSend?.amount))}
              </Text>
            </Flex>
          </Flex>

          <Flex flexDir="column" gap="m" w="full">
            <Button
              w="full"
              onClick={handleConfirmAndSend}
              textTransform="capitalize"
            >
              {`${t('attributes.send')} ${t('attributes.order')}`}
            </Button>
            <Button w="full" variant="outline" onClick={handleBack}>
              {t('screens.invest.confirmOrder.backAndEdit')}
            </Button>
          </Flex>
        </Flex>
      </IfRender>
    </Box>
  );
};

type ConfirmSendOrderAdvisorProps = {
  orderDataToSend: InvestmentOrder;
  handleBack: () => void;
  handleConfirmAndSend: () => void;
};
